export const environment = {
    mock: false,
    production: true,
    apiUrl: window["env" as any]["apiUrl" as any] || "default",
    tenantId: window["env" as any]["tenantId" as any] || "default",
    clientId: window["env" as any]["clientId" as any] || "default",
    backendId: window["env" as any]["backendId" as any] || "default",
    redirectUri: window["env" as any]["redirectUri" as any] || "default"
};